export const HUD_HOME_STUDENT_STATUS_FIELD_NAMES = {
  instituteName: 'instituteName',
  advisorName: 'advisorName',
  telephone: 'telephone',
  emailAddress: 'emailAddress',
  dependentOfHousehold: 'dependentOfHousehold',
  studentAtInstitutionOfHigherEducation:
    'studentAtInstitutionOfHigherEducation',
  married: 'married',
  dateMarried: 'dateMarried',
  dependentChildLivingWithMe: 'dependentChildLivingWithMe',
  dependentChildren: 'dependentChildren',
  dependentsOtherThanChildOrSpouse: 'dependentsOtherThanChildOrSpouse',
  twentyFourYearsOrOlder: 'twentyFourYearsOrOlder',
  veteran: 'veteran',
  graduateOrProfessionalStudent: 'graduateOrProfessionalStudent',
  disabledStudentSection8: 'disabledStudentSection8',
  independentForAtLeastOneYear: 'independentForAtLeastOneYear',
  livingWithParentsOrGuardians: 'livingWithParentsOrGuardians',
  parentsOrGuardiansReceivingSection8: 'parentsOrGuardiansReceivingSection8',
  parents: 'parents',
  parentName: 'name',
  parentAddress: 'address',
  parentCity: 'city',
  parentState: 'state',
  parentZip: 'zip',
  parentTelephone: 'telephone',
  receivingFinancialAssistance: 'receivingFinancialAssistance',
  financialAssistanceSources: 'financialAssistanceSources',
};
